import { render } from "./index.vue?vue&type=template&id=6aa4ba55&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6aa4ba55&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa4ba55"]])

export default __exports__